export interface HtmlSlideFile {
    name: string;
    html: string;
}

export function isHtmlFileName(name: string): boolean {
    return /\.(html|htm)$/i.test(name);
}

export function htmlSlideName(fileName: string): string {
    const withoutExtension = fileName.replace(/\.(html|htm)$/i, '').trim();
    return withoutExtension.slice(0, 100) || 'HTML';
}

// Multi-file pickers (notably GTK on Linux) return the selection in reverse of the folder listing.
export function sortHtmlSlideFiles<T extends {name: string}>(files: T[]): T[] {
    return [...files].sort((a, b) => a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}));
}

export function readHtmlSlideFiles(files: File[]): Promise<HtmlSlideFile[]> {
    return Promise.all(
        sortHtmlSlideFiles(files).map(
            (file) =>
                new Promise<HtmlSlideFile>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        resolve({
                            name: htmlSlideName(file.name),
                            html: String(reader.result ?? ''),
                        });
                    };
                    reader.onerror = () => reject(reader.error);
                    reader.readAsText(file);
                })
        )
    );
}
